module.exports = __webpack_public_path__ + "img/isPr_not1024_lost.6cbbe9d8.png";